import { doc, collection, serverTimestamp, updateDoc } from "firebase/firestore";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../components/page-header";
import { db } from "../../firebase";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SavingIndicator from "../../components/saving-indicator";
import { Puzzle } from "../../models/Puzzle";
import PuzzleForm from "../../components/puzzle-form";
import { getPuzzle } from "../../services/api";

export default function PuzzleEditPage() {
    const { id } = useParams<string>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [puzzle, setPuzzle] = useState<Puzzle | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getPuzzle(id).then((res) => {
            if (res) {
                setPuzzle(res);
            } else {
                setError("Puzzle not found!!");
            }
        })
    }, [])

    const handleSubmit = async (data: any) => {
        setLoading(true);

        // Add timeModified
        data.timeModified = serverTimestamp();

        // Temp Solution for missing timeCreated
        if (!puzzle?.timeCreated) {
            data["timeCreated"] = serverTimestamp();
        }

        if (puzzle) {
            var newData = { ...puzzle, ...data };

            // Remove unneeded fields
            delete newData['id'];

            try {
                const ref = doc(collection(db, "puzzles"), id);
                await updateDoc(ref, newData);
                navigate("/admin/puzzles");
            } catch (e) {
                console.log(e);
                setError("Error!!");
                setLoading(false)
            }
        }
    }

    return (
        <>
            <PageHeader title={t("edit_puzzle_title")} />
            <Container fluid>
                {puzzle
                    ? (
                        <>
                            {error &&
                                <div className="text-center text-danger mb-3 fw-bold" dir="ltr">
                                    {error}
                                </div>
                            }
                            {loading
                                ? <SavingIndicator />
                                : <PuzzleForm
                                    target={puzzle}
                                    onSubmit={handleSubmit}
                                    onCancel={() => navigate("/admin/puzzles")}
                                />
                            }
                        </>
                    )
                    : <div className="text-center text-danger mb-3 fw-bold" dir="ltr">
                        {error}
                    </div>
                }
            </Container>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
        </>
    )
}